export default "__VITE_ASSET__522f0523__"